import { gql } from 'apollo-boost';

export const runTaskMutation = gql`
  mutation runTask($task: String!) {
    runTask(task: $task) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
